<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="中转站名称" prop="transferStationName">
            <el-input
              v-model="formData.transferStationName"
              placeholder="请输入中转站名称"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="中转站类型" prop="transferStationType">
            <dict-select
              v-model="formData.transferStationType"
              placeholder="请选择中转站类型"
              default
              filterable
              :body="transferStationTypeDictParams"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="是否是虚拟中转站">
            <el-radio-group v-model="formData.isVirtual">
              <el-radio label="Y">是</el-radio>
              <el-radio label="N">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="三方站点编号">
            <el-input
              v-model="formData.tdpStationNo"
              placeholder="请输入三方站点编号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="承运商">
            <dict-select
              style="width: 100%"
              size="medium"
              filterable
              v-model="formData.carrierCode"
              url="/master/carrier/info/select"
              placeholder="请选择承运商"
            />
          </el-form-item>
        </el-col> -->

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="联系人姓名" prop="contactName">
            <el-input
              v-model="formData.contactName"
              placeholder="请输入联系人姓名"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="联系人手机号" prop="contactMobile">
            <el-input
              v-model="formData.contactMobile"
              placeholder="请输入联系人手机号"
              maxlength="11"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="固定电话" prop="contactPhone">
            <el-input
              v-model="formData.contactPhone"
              placeholder="请输入固定电话"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="联系人E-mail" prop="contactEmail">
            <el-input
              v-model="formData.contactEmail"
              placeholder="请输入联系人E-mail"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="所属机构" prop="orgCode">
            <org-cascader
              :valueString.sync="formData.orgAllCode"
              :lastValue.sync="formData.orgCode"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="托管机构" prop="trusteeshipOrgCode">
            <org-cascader
              :valueString.sync="formData.trusteeshipOrgAllCode"
              :lastValue.sync="formData.trusteeshipOrgCode"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="省/市/区县" prop="cityCode">
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="formData.provinceCode"
              :provinceName.sync="formData.provinceName"
              :cityCode.sync="formData.cityCode"
              :cityName.sync="formData.cityName"
              :districtCode.sync="formData.districtCode"
              :districtName.sync="formData.districtName"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="所在区域">
            <el-input v-model="formData.areaName" placeholder="请输入所在区域" clearable>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="提货围栏半径(米)">
            <el-input-number
              v-model="formData.pickUpFence"
              placeholder="请输入提货围栏半径"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="收货围栏半径(米)">
            <el-input-number
              v-model="formData.receivingFence"
              placeholder="请输入收货围栏半径"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            label="中转站地址"
            prop="transferStationAddress"
            size="small"
          >
            <el-input
              size="small"
              placeholder="请输入中转站地址"
              v-model="formData.transferStationAddress"
            >
              <el-button
                slot="append"
                size="small"
                icon="el-icon-map-location"
                @click="coordPickerDialogVisible = true"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="备注" prop="transferStationRemarks">
          <el-input
            v-model="formData.transferStationRemarks"
            placeholder="请输入备注信息"
            type="textarea"
          >
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="有效状态" prop="transferStationStatus">
            <el-radio-group v-model="formData.transferStationStatus">
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <coord-picker-dialog
      v-if="coordPickerDialogVisible"
      :visible.sync="coordPickerDialogVisible"
      :address.sync="formData.transferStationAddress"
      :longitude.sync="formData.longitude"
      :latitude.sync="formData.latitude"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import { mapActions } from 'vuex'
export default {
  props: {
    disabled: Boolean,
    params: { type: Object, default: () => {} },
  },
  components: {},
  data() {
    return {
      coordPickerDialogVisible: false,
      transferStationTypeDictParams: { type: 'transferStationType' },
      regionShow: false,
      backDialogVisible: false,
      formData: {
        transferStationStatus: 'Y',
        isVirtual: 'N',
        transferStationName: '',
      },
      rules: {
        transferStationName: [
          {
            required: true,
            message: '请输入中转站名称',
            trigger: 'blur',
          },
        ],
        transferStationType: [
          {
            required: true,
            message: '请输入中转站类型',
            trigger: 'change',
          },
        ],
        contactName: [
          {
            required: true,
            message: '请输入联系人姓名',
            trigger: 'blur',
          },
        ],
        contactMobile: [
          {
            required: true,
            message: '请输入联系人手机号',
            trigger: 'blur',
          },
        ],
        contactEmail: [
          {
            required: false,
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
        orgCode: [
          {
            required: true,
            message: '请选择所属机构',
            trigger: 'change',
          },
        ],
        trusteeshipOrgCode: [
          {
            required: true,
            message: '请选择托管机构',
            trigger: 'change',
          },
        ],
        transferStationStatus: [
          {
            required: true,
            message: '请选择有效状态',
            trigger: 'change',
          },
        ],
        transferStationAddress: [
          {
            required: true,
            message: '请输入中转站地址',
            trigger: 'blur',
          },
        ],
        cityCode: [
          {
            required: true,
            message: '请选择省市区县',
            trigger: 'change'
          }
        ]
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.params.transferStationCode) return (this.regionShow = true)
      this.$api
        .masterTransferStationDetailApi({
          transferStationCode: this.params.transferStationCode,
        })
        .then((res) => {
          this.formData = res.body
          this.regionShow = true
        })
    },
    async save() {
      let result = await validate.formValidate([this.$refs.formData])
      if (!result) return

      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .masterTransferStationSaveApi(this.formData)
        .then(() => {
          loadingInstance.close()
          this.saveOkQuestion()

          //刷新列表
          this.$eventBus.$emit('transferStationTableReload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    saveOkQuestion() {
      this.$alert('中转站数据保存成功', '提示信息', {
        confirmButtonText: '确定',
        callback: () => {
          this.closeCurPage()
        },
      })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
